// extracted by mini-css-extract-plugin
export default {"input":"ContactForm_input__x9kVq","submit":"ContactForm_submit__0EEI2"};